import * as React from 'react';

import * as Styled from './pop-over.styles';
import type { PopOverPrimitiveProps } from './pop-over.types';

export const PopOverPrimitive = React.forwardRef<
  HTMLDivElement,
  PopOverPrimitiveProps
>(
  (
    {
      children,
      className,
      containerRef,
      onClose,
      position,
      showCloseButton,
      ...props
    },
    forwardedRef
  ) => (
    <Styled.Wrapper
      className={className}
      data-xds="PopOver"
      ref={(node) => {
        if (containerRef) {
          containerRef.current = node;
        }

        if (typeof forwardedRef === 'function') {
          forwardedRef(node);
          return;
        }

        if (forwardedRef) {
          forwardedRef.current = node;
        }
      }}
      style={{ ...position }}
      tabIndex={-1}
      {...props}
    >
      {showCloseButton && <Styled.CloseButton onClick={onClose} size="large" />}
      {children}
    </Styled.Wrapper>
  )
);

PopOverPrimitive.displayName = 'PopOver (Primitive)';
